module.exports = __webpack_public_path__ + "img/IAR5.c62f118d.png";